import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import { LoadingSection } from "../Spinner";

export function AdminLayout() {
  const navigate = useNavigate();
  const { data, isError, isLoading } = useQuery({
    queryKey: ["admin", "me"],
    queryFn: () => api<{ user: { email: string; role: string } }>("/admin/auth/me"),
    retry: false,
  });

  useEffect(() => {
    if (isError) navigate("/admin/login", { replace: true });
  }, [isError, navigate]);

  if (isLoading) return <LoadingSection className="min-h-screen" />;
  if (!data) return null;

  const logout = async () => {
    await api("/admin/auth/logout", { method: "POST" });
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="grid min-h-screen grid-cols-[240px_1fr] bg-ink-100">
      <aside className="bg-ink-900 p-5 text-ink-100">
        <div className="mb-8 font-display text-lg font-bold uppercase">Admin · Héraclès</div>
        <nav className="flex flex-col gap-1">
          {[
            ["dashboard", "Dashboard"],
            ["leads", "Messages"],
            ["gyms", "Salles"],
            ["coaches", "Coachs"],
            ["schedule", "Planning"],
            ["pricing", "Tarifs"],
            ["settings", "Apparence"],
            ["audit", "Journal"],
          ].map(([slug, label]) => (
            <NavLink
              key={slug}
              to={`/admin/${slug}`}
              className={({ isActive }) =>
                `rounded px-3 py-2 text-sm font-semibold uppercase tracking-wider ${
                  isActive ? "bg-brand-500 text-white" : "hover:bg-white/10"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
        <button onClick={logout} className="mt-10 text-xs text-ink-300 hover:text-white">
          Déconnexion ({data.user.email})
        </button>
      </aside>
      <main className="p-8">
        <Outlet />
      </main>
    </div>
  );
}
